(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pulvis-shop-rating"] && !Shopify.designMode) return;
  try {
    if (!window.pulvisAggregateRatingLoaded) {
 window.pulvisAggregateRatingLoaded = true;
 fetch('https://api-cdn.yotpo.com/v1/widget/cFV8t1vXLl79Qf1VepnSkNYhSvzlHqmakMgWLyJ0/reviews.json?per_page=1')
 .then(response => response.json()).then(data => {
 const rating = data && data.response && data.response.bottomline;
 if (!rating || !rating.total_review || !rating.average_score) return;
 document.querySelectorAll('[data-pulvis-aggregate-rating]').forEach(row => {
 row.querySelector('[data-pulvis-score]').textContent = (Math.floor(rating.average_score * 10) / 10).toFixed(1);
 row.querySelector('[data-pulvis-count]').textContent = Number(rating.total_review).toLocaleString(document.documentElement.lang || 'en');
 });
 }).catch(() => {});
}
  } catch(e) { console.error(e); }
})();

})();
